$('#doctors_clinic, #doctors_service').change(function(){
	let clinic = $('#doctors_clinic').val();
	let service = $('#doctors_service').val();
	
	if (!clinic && !service)
	{
		$('.doctors-page__item').show();
	}
	else
	{
		$('.doctors-page__item').each(function(){
			let el = $(this);
			if ((!clinic || el.attr('data-clinics').split(',').indexOf(clinic) != -1) &&
				(!service || el.attr('data-services').split(',').indexOf(service) != -1))
				el.show();
			else
				el.hide();
		});
	}
	
});

/*$('#doctors_service').change(function(){
	let service = $(this).val();
	
	if (!service)
	{
		$('.doctors-page__item').show();
	}
	else
	{
		$('.doctors-page__item').each(function(){
			let el = $(this);
			if (el.attr('data-services').split(',').indexOf(service) != -1)
				el.show();
			else
				el.hide();
		});
	}
	
});*/

$('.form-clinics__reset').click(function(){
	$('#doctors_clinic').val('').trigger('change');
	$('#doctors_service').val('').trigger('change');
});